import { ReactComponent } from './house-car-m.svg';

export const HouseCarIconM = ReactComponent;

export default ReactComponent;
